import { useEffect } from "react";
import { Box, Container, Grid, Typography, Link, Divider, Stack, useTheme, useMediaQuery } from "@mui/material";
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { LinkedIn, Facebook, Instagram, YouTube } from "@mui/icons-material";
import LogoFooter from '../ui-utils/latestPics/Footer.svg';
import { backendHosts } from "../ui-utils/apiConfig";
import en from "../i18n/English/Home/footer.json";
import hi from "../i18n/Hindi/Home/footer.json";
import kn from "../i18n/Kannada/Home/footer.json";
import ma from "../i18n/Marathi/Home/footer.json";
import gu from "../i18n/Gujarati/Home/footer.json";
import { useLanguage } from "../Context/LangContext";

export default function MainFooter() {

    const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const { language } = useLanguage();
    const translations = { en, hi, kn,ma,gu };
    const t = translations[language];

  const socialLinks = [
  { name: "LinkedIn", icon: LinkedIn, link: "https://www.linkedin.com/in/tradeboss-tvmscl-116503381" },
  // { name: "Facebook", icon: Facebook, link: "#" },
  { name: "Instagram", icon: Instagram, link: "https://www.instagram.com/tradeboss_tvmscl?igsh=eG9tMmVoeWJ1ZHY0" },
  { name: "YouTube", icon: YouTube, link: "https://www.youtube.com/@TradebossTVMSCL" },
];

  const location = useLocation();

  useEffect(() => {
    // ✅ Scroll to top smoothly when route changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]); // Runs whenever URL changes

    return (
        <Box
            sx={{

          background: "#130D15",
          color: "#85DCFF",
                py: 4,
                px: "100px",
                "@media (max-width:1315px)": {
                    px: "50px",
                },
                "@media (max-width:1210px)": {
                    px: "25px",
                },
                "@media (max-width:1160px)": {
                    px: "10px",
                },
            }}
        >

            <Container maxWidth="1200px" >
                <Grid container spacing={4}>
                    <Grid item xs={12} md={2} mr={8}
                        sx={{
                            display: {
                              xs: "flex",     // Use flex on xs
                              md: "block"     // Revert to default block layout at md and above
                            },
                            justifyContent: {
                              xs: 'flex-start',   // Right-align image on xs
                            //   md: 'flex-start'  // Optional; ignored since display is block above md
                            },
                            marginRight:{
                                xs:0,
                                md:8
                            }
                          }}
                        >
                        <Box
                            component="img"
                            src={LogoFooter}
                            alt="TradeBoss Logo"
                            sx={{
                                width: "177px",
                                display: "block",
                                "@media (max-width:1315px)": {
                                    width: "150px",
                                },
                                "@media (max-width:900px)": {
                                    width: "140px",
                                },
                            }}
                        />

                    </Grid>

                    <Grid item xs={12} md={2} sx={{
                        mr: "34px", "@media (max-width:1160px)": {
                            mr: "24px",
                        },
                        "@media (max-width:975px)": {
                            mr: "18px",
                        },
                        "@media (max-width:940px)": {
                            mr: "14px",
                        },
                    }}>
              <Typography sx={{
                fontFamily: "Inter700", fontSize: "calc(20px + var(--font-delta))" ,mb:"32px","@media (max-width:1000px)": {
                          mb: "24px",
                                }}} gutterBottom>
                            {/* Platform */}
                            {t.platform}
                        </Typography>
                        <Stack spacing={2}>
                <Link href={backendHosts.TRADEPLF} color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize: "calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                    fontSize: "calc(14px + var(--font-delta))",
                  }
                }}>
                  {/* Trading Platform */}
                  {t.platformLinks[0]}
                  </Link>
                <Link href={backendHosts.EXPERTRECMD} color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize: "calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                    fontSize: "calc(14px + var(--font-delta))",
                                }
                            }}>
                              {/* Expert Recommendations */}
                  {t.platformLinks[1]}
                              </Link>
                <Link href={backendHosts.WEALTHVAULT} color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"Wealth Vault" , "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Wealth Vault */}
                  {t.platformLinks[2]}
                                  </Link>
                {/* <Link href="#" color="#FFFFFF" underline="none" sx={{fontFamily:"Inter400",fontSize:"16px" , "@media (max-width:1160px)": {
                                    fontSize: "14px",
                                }}}>Back office</Link> */}

                <Typography sx={{
                  fontFamily: "Inter700", fontSize: "20px", mb: "32px", "@media (max-width:1000px)": {
                    mb: "24px",
                  }
                }}>{t.account}</Typography>

                <div style={{ width: '100%' }}>
                  <a
                    href="https://admin-backend.tradeboss.co/document/saral-account"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      paddingTop: '10px',
                      textDecoration: 'none',
                      color: '#ffffff',
                      fontFamily: 'Inter400',
                      fontSize: '16px',
                      display: 'inline-block',
                      cursor: 'pointer',
                    }}
                  >
                    {t.accountLinks[0]}
                  </a>
                </div>

                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={2} sx={{
                        mr: "34px", "@media (max-width:1160px)": {
                            mr: "24px",
                        },
                        "@media (max-width:975px)": {
                            mr: "18px",
                        },
                        "@media (max-width:940px)": {
                            mr: "14px",
                        },
                    }}>
              <Typography sx={{
                fontFamily: "Inter700", fontSize: "calc(20px + var(--font-delta))" ,mb:"32px","@media (max-width:1000px)": {
                                    mb:"24px",
                                }}} gutterBottom>
                            {/* Policies */}
                {t.policies}
                        </Typography>
                        <Stack spacing={2}>
                <Link component={RouterLink} to="/Privacy_Policy" color="#FFFFFF" underline="none" sx={{fontFamily:"Inter400",fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Privacy Policy */}
                             {t.policyLinks[0]}
                                  </Link>
                <Link component={RouterLink} to="/refund_policy" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Refund Policy */}
                         {t.policyLinks[1]}
                                  </Link>
                <Link component={RouterLink} to="/termsandconditions" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize: "calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                    fontSize: "calc(14px + var(--font-delta))",
                                }
                            }}>
                                {/* Rights & Obligations(T and C's) */}
                  {t.policyLinks[2]}
                                </Link>
                <Link component={RouterLink} to="/cdsl" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Rights & Obligations(CDSL) */}
                   {t.policyLinks[3]}
                                  </Link>
                <Link component={RouterLink} to="/risk_disclosure" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Risk Disclosure */}
                  {t.policyLinks[4]}
                                  </Link>
                <Link component={RouterLink} to="/bsda" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                }
                }}> {t.policyLinks[5]}</Link>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={2} sx={{
                        mr: "34px", "@media (max-width:1160px)": {
                            mr: "24px",
                        },
                        "@media (max-width:975px)": {
                            mr: "18px",
                        },
                        "@media (max-width:940px)": {
                            mr: "14px",
                        },
                    }}>
              <Typography sx={{
                fontFamily: "Inter700", fontSize: "calc(20px + var(--font-delta))" ,mb:"32px","@media (max-width:1000px)": {
                                    mb:"24px",
                                }}} gutterBottom>
                            {/* Utilities */}
                {t.utilities}
                        </Typography>
                        <Stack spacing={2}>
                <Link component={RouterLink} to="/holiday_calendar" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                                    fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Holiday Calendar */}
                  {t.utilityLinks[0]}
                                  </Link>
                <Link component={RouterLink} to="/tools-calculators/brokerage" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Brokerage Calculator */}
                  {t.utilityLinks[1]}
                                  </Link>
                            {/* <Link href="#" color="inherit" underline="none" sx={{fontFamily:"Inter400",fontSize:"16px", "@media (max-width:1160px)": {
                                    fontSize: "14px",
                                }}}>Margin Calculator</Link> */}
                <Link component={RouterLink} to="/pricing" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Pricing */}
                  {t.utilityLinks[2]}
                                  </Link>
                <Link component={RouterLink} to="/support/contact" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Contact us */}
                  {t.utilityLinks[3]}
                                  </Link>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={2}>
              <Typography sx={{
                fontFamily: "Inter500", fontSize: "calc(20px + var(--font-delta))" ,mb:"32px","@media (max-width:1000px)": {
                                    mb:"0px",
                                }}} gutterBottom>
                            &nbsp;
                        </Typography>
                        <Stack spacing={2}>
                <Link component={RouterLink} to="/aboutus" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                                    fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* About Us */}
                           {t.about[0]}
                                  </Link>
                
                <Typography
                  sx={{
                    color: "#FFFFFF",
                    fontFamily: "Inter400",
                    fontSize: "calc(16px + var(--font-delta))",
                  }}
                >
                  {t.about[1]}
                </Typography>
                <Link component={RouterLink} to="/circular" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Circular */}
                  {t.about[2]}
                                  </Link>
                <Link component={RouterLink} to="/issue_disclosures" color="#FFFFFF" underline="none" sx={{
                  fontFamily: "Inter400", fontSize:"calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                  fontSize: "calc(14px + var(--font-delta))",
                                }}}>
                                  {/* Issue Disclosures */}
                  {t.about[3]}
                                  </Link>
                <Link
                  href="https://tradeboss-images.blr1.digitaloceanspaces.com/public/Website/CDSL_Investor_Charter.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="#FFFFFF"
                  underline="none"
                  sx={{
                    fontFamily: "Inter400", fontSize: "calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                      fontSize: "calc(14px + var(--font-delta))",
                    }
                  }}
                >
                  {t.about[4]}
                </Link>

                <Link
                  href="https://tradeboss-images.blr1.digitaloceanspaces.com/public/Website/CDSL%20Annexure-C.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="#FFFFFF"
                  underline="none"
                  sx={{
                    fontFamily: "Inter400", fontSize: "calc(16px + var(--font-delta))", "@media (max-width:1160px)": {
                      fontSize: "calc(14px + var(--font-delta))",
                    }
                  }}
                >
                  {t.about[5]}
                </Link>

                        </Stack>
                    </Grid>
                </Grid>

          <Divider sx={{ my: 4, borderColor: "#FFFFFF" }} />

                <Grid
        container
        style={{ width: "100%", justifyContent: "left",  }}
      >
        <Grid item xs={11} md={10}>

        </Grid>
      </Grid>

          <Typography style={{ color: "#FFFFFF", fontSize: "calc(16px + var(--font-delta))", marginBottom: "3px" ,fontFamily:"Inter500"}}>
           Attention Investor
         </Typography>

      <Grid
        container
        style={{ width: "100%", justifyContent: "left",margin:"5px 0px" }}
      >
        <Grid
          item
          xs={12}
          md={12}
          style={{ padding: "5px", background: "#241E41" }}
        >
          {/* <marquee>
                <Typography style={{ color: "#F3D45E", fontSize: isMobile ? "calc(12px + var(--font-delta))" : "calc(14px + var(--font-delta))",fontFamily:"Inter400" }}>
            1. For Stock Broking Transaction &#x27;Prevent unauthorised transactions in your account --&gt; Update your mobile numbers/email IDs with your stock brokers. Receive information of your transactions directly from Exchange on your mobile/email at the end of the day...Issued in the interest of Investors.  2. For Depository Transaction &#x27;Prevent Unauthorized Transactions in your demat account --&gt; Update your Mobile Number with your Depository Participant. Receive alerts on your Registered Mobile for all debit and other important transactions in your demat account directly from CDSL/NSDL on the same day...Issued in the interest of investors.  3. KYC is a one time exercise while dealing in securities markets - once KYC is done through a SEBI registered intermediary (Broker, DP, Mutual Fund etc.), you need not undergo the same process again when you approach another intermediary. 4. If you are subscribing to an IPO, there is no need to issue a cheque. Please write the Bank account number and sign the IPO application form to authorize your bank to make payment in case of allotment. In case of non allotment the funds will remain in your bank account.
            </Typography>
          </marquee> */}
              <Box
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  position: "relative",

                  "@keyframes tickerScroll": {
                    "0%": {
                      transform: "translateX(100vw)",
                    },
                    "100%": {
                      transform: "translateX(-100%)",
                    },
                  },
                }}
              >
                <Typography
                  sx={{
                    color: "#F3D45E",
                    fontSize: isMobile
                      ? "calc(12px + var(--font-delta))"
                      : "calc(14px + var(--font-delta))",
                    fontFamily: "Inter400",
                    display: "block",
                    width: "max-content",
                    whiteSpace: "nowrap",
                    animation: "tickerScroll 100s linear infinite",

                    "@media (prefers-reduced-motion: reduce)": {
                      animation: "none",
                      transform: "none",
                      width: "auto",
                      whiteSpace: "normal",
                    },
                  }}
                >
                  1. For Stock Broking Transaction 'Prevent unauthorised transactions
                  in your account --&gt; Update your mobile numbers/email IDs with
                  your stock brokers. Receive information of your transactions directly
                  from Exchange on your mobile/email at the end of the day...Issued in
                  the interest of Investors.

                  2. For Depository Transaction 'Prevent Unauthorized Transactions in
                  your demat account --&gt; Update your Mobile Number with your
                  Depository Participant. Receive alerts on your Registered Mobile
                  for all debit and other important transactions in your demat account
                  directly from CDSL/NSDL on the same day...Issued in the interest
                  of investors.

                  3. KYC is a one time exercise while dealing in securities markets -
                  once KYC is done through a SEBI registered intermediary (Broker, DP,
                  Mutual Fund etc.), you need not undergo the same process again when
                  you approach another intermediary.

                  4. If you are subscribing to an IPO, there is no need to issue a
                  cheque. Please write the Bank account number and sign the IPO
                  application form to authorize your bank to make payment in case of
                  allotment. In case of non allotment the funds will remain in your
                  bank account.
                </Typography>
              </Box>
        </Grid>
      </Grid>

      <Grid
        container
        style={{ width: "100%", justifyContent: "left" }}
      >
        <Grid item xs={12} md={12}>
              <Typography style={{
                color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", marginBottom: "3px", fontFamily: "Inter400" ,
                maxWidth: "100%",
                whiteSpace: "normal",
                textAlign: "justify",
                lineHeight: "1.5" }}>
                {/* Triveni Management Consultancy Services Limited .: Member of NSE and BSE with NSE Membership No: 06528, BSE Membership No:3134, CDSL Registration No: IN-DP-797-2025, SEBI Registration No.:  INZ000219738. Registered office : A-2, Bandra Liberty Co-Op Hsg. Soc. 98, Hill Road,
                Bandra (West), Mumbai, Maharastra - 400050 and Corporate Office : 14/2, Western India House, Sir P.M. Road, Fort, Mumbai 400 001. */}

                {t.address}
          </Typography>
              <Typography style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", marginBottom: "3px" ,fontFamily:"Inter400"}}>
            {/* For any grievances related to Stock Broking/DP, please write to Grievances@tradeboss.co, please ensure you carefully read the Risk Disclosure Document as prescribed by SEBI. */}

            {t.text}
          </Typography>
        </Grid>
      </Grid>
      <Typography
            // variant="h6"
            style={{
              color: "#FFFFFF",
              fontFamily:"Inter500",
              fontSize: "calc(12px + var(--font-delta))",
              marginBottom: "0px",
              marginTop: "10px",
            }}
          >
            {/* Attention Investor */}
            {t.attentionInvestor}
          </Typography>

      <Grid container style={{ width: "100%", justifyContent: "left", paddingTop: "3px" }}>

        <Grid item xs={12} md={12} style={{ display: "flex", flexWrap: "wrap" }}>
        <Grid item xs={12} md={12} style={{ display: "flex", flexWrap: "wrap" }}>
                <Grid style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))" ,fontFamily:"Inter400"}}>
            {/* Stock brokers can accept securities as margins from clients only by way of pledge in the depository system w.e.f September 01, 2020. */}

            {t.text1}
            </Grid>
            </Grid>

            <Grid item xs={12} md={12} style={{ display: "flex", flexWrap: "wrap" }}>
                <Grid style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))" ,fontFamily:"Inter400"}}>
            {/* Update your e-mail and phone number with your stock broker / depository participant and receive OTP directly from depository on your e-mail and/or mobile number to create pledge. */}
                  {t.text2}
            </Grid>
            </Grid>

            <Grid item xs={12} md={12} style={{ display: "flex", flexWrap: "wrap" }}>
                <Grid style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))" ,fontFamily:"Inter400"}}>
            {/* Check your securities / MF / bonds in the consolidated account statement issued by NSDL/CDSL every month. */}
                  {t.text3}
            </Grid>
            </Grid>

            <Grid item xs={12} md={12} style={{ display: "flex", flexWrap: "wrap",marginTop:"10px",marginBottom:"10px" }}>
                <Grid style={{
                  color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", fontFamily: "Inter400", maxWidth: "100%",         // Ensures text wraps within the container
                  whiteSpace: "normal",     // Allows normal wrapping (default but safe)
                  textAlign: "justify",     // Aligns both sides (left + right)
                  lineHeight: "1.5"
}}>

  {t.note}

            {/* Note: As a policy we do not give stock tips or recommendations and have not authorized anyone to give this on behalf of us. If you know anyone claiming to be a part of TradeBoss / Triveni / Raise or our associate companies or partners and offering such services, please report us on admin@tradeboss.co. Important Information for Investors: To prevent unauthorized transactions in your trading / demat account, do not share your account details, credentials or any personal details with anyone. Keep your mobile number updated with your Stock Broker, Depository Participant and ensure that the same is registered with Stock Exchanges, Depository and KRAs. You will receive alerts and information on your registered mobile number / email for debit and other important transactions in your demat account directly from CDSL / Exchange on the same day. KYC is one time exercise while dealing in securities markets - once KYC is done through a SEBI registered intermediary (Stock Broker, DP, Mutual Fund, etc.), you need not undergo the same process again when you approach another intermediary. No need to issue cheques by investors while subscribing to IPO. Just write the bank account number and sign in the application form to authorise your bank to make payment in case of allotment. No worries for refund as the money remains in investor's account. This is issued in the interest of investors. */}

</Grid>
            </Grid>

            <Grid item xs={12} md={12} style={{ display: "flex", flexWrap: "wrap",marginTop:"10px",marginBottom:"10px" }}>
                <Grid style={{
                  color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", fontFamily: "Inter400", maxWidth: "100%",         // Ensures text wraps within the container
                  whiteSpace: "normal",     // Allows normal wrapping (default but safe)
                  textAlign: "justify",     // Aligns both sides (left + right)
                  lineHeight: "1.5"
}}>
{/*
            Triveni Management Consultancy Services Limited also known as TradeBoss is only an order collection platform that collects orders on behalf of clients and places them on BSE StarMF for execution. Client expressly agrees that Tradeboss is not liable or responsible and does not represent or warrant any damages regarding non- execution of orders or any incorrect execution of orders with regard to the funds chosen by the client or due to, but not being limited to, any link/system failure, delay in transfer of the funds on account of any unforeseen circumstances/issues in the banking system/payment aggregators or any other problems that may result in a delay in crediting the funds into the BSE Star MF's bank account. */}
            {t.text4}
</Grid>
            </Grid>

            <Grid item xs={12} md={12} style={{ display: "flex", flexWrap: "wrap",marginTop:"10px",marginBottom:"10px" }}>
                <Grid style={{
                  color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", fontFamily: "Inter400", maxWidth: "100%",         // Ensures text wraps within the container
                  whiteSpace: "normal",     // Allows normal wrapping (default but safe)
                  textAlign: "justify",     // Aligns both sides (left + right)
                  lineHeight: "1.5"
}}>

            {/* Mutual fund investments are subject to market risks, read all scheme related documents carefully before investing. TradeBoss is not a distributor or agent of any mutual fund. Mutual Funds are not exchange-traded products. Any related disputes will not have access to the Exchange-investor redressal forum or arbitration mechanism. */}
                  {t.text5}
</Grid>
            </Grid>

            <Grid item xs={12} md={12} style={{ display: "flex", flexWrap: "wrap",marginTop:"10px",marginBottom:"10px" }}>
                <Typography style={{
                  color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", fontFamily: "Inter400", maxWidth: "100%",         // Ensures text wraps within the container
                  whiteSpace: "normal",     // Allows normal wrapping (default but safe)
                  textAlign: "justify",     // Aligns both sides (left + right)
                  lineHeight: "1.5"
}}>

            {/* Download client registration documents (Rights & Obligations, Risk Disclosure Document, Do's & Don'ts) in vernacular language: */}
                  {t.text6}

            </Typography>
                <Typography
                  onClick={() => window.open("https://www.nseindia.com/trade/members-client-registration-documents", "_blank")}
                  style={{ color: "#1E90FF", fontSize: "calc(12px + var(--font-delta))", marginLeft: "4px", cursor: "pointer", fontFamily: "Inter500" }}
                >
                  NSE{" "}
                </Typography>

                <Typography style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))" ,fontFamily:"Inter400", marginLeft: "4px"}}>
          |
          </Typography>

                <Typography
                  onClick={() => window.open("https://www.bseindia.com/static/investors/client_regislanguages.aspx?expandable=3", "_blank")}
                  style={{ color: "#1E90FF", fontSize: "calc(12px + var(--font-delta))", marginLeft: "4px", cursor: "pointer", fontFamily: "Inter500" }}
                >
                  BSE
                </Typography>

                <Typography style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))" ,fontFamily:"Inter400",marginLeft: "4px"}}>
         {/* |{" "} */}
          </Typography>
          {/* <Typography
            onClick={() => window.open("https://www.mcxindia.com/membership/members-compliance/vernacular-language", "_blank")}
            style={{ color: "#1E90FF", fontSize: "12px", marginLeft: "4px", cursor: "pointer",fontFamily:"Inter500" }}
          >
           MCX
          </Typography> */}
            </Grid>

              <Typography style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))" ,fontFamily:"Inter400"}}>
            {/* Procedure to file a compliant on SEBI */}
                {t.text7}{" "}
          </Typography>
          <Typography
            onClick={() => window.open("https://scores.sebi.gov.in/", "_blank")}
                style={{ color: "#1E90FF", fontSize: "calc(12px + var(--font-delta))", marginLeft: "4px", cursor: "pointer",fontFamily:"Inter500" }}
          >
            SCORES
          </Typography>
              <Typography style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", marginLeft: "4px" ,fontFamily:"Inter400"}}>
          {/* Register on the SCORES portal. Mandatory details for filing
          complaints on SCORES: Name, PAN, Address, Mobile Number E-mail ID. */}
                {t.text8}
          </Typography>
        </Grid>
      </Grid>

      <Grid container style={{  width: "100%", justifyContent: "left", paddingTop: "3px" }}>
        <Grid item xs={12} md={12}>
              <Typography style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))" ,fontFamily:"Inter400"}}>
            {/* Procedure to file Investor Dispute */}
                {t.text9}{" "}
            <span
              onClick={() => window.open("https://smartodr.in/login", "_blank")}
              style={{ color: "#1E90FF", cursor: "pointer",fontFamily:"Inter500" }}
            >
              SMARTODR
            </span>
          </Typography>
        </Grid>
      </Grid>

      <Grid container style={{  width: "100%", justifyContent: "left", paddingTop: "3px" }}>
        <Grid item xs={12} md={12}>
              <Typography style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))",fontFamily:"Inter400" }}>
            {/* Benefits: Effective Communication, Speedy redressal of the grievances. */}
                {t.text10}
          </Typography>
        </Grid>
      </Grid>

      <Grid container style={{  width: "100%", justifyContent: "left" }}>
        <Grid item xs={12} md={12}>
              <Typography style={{
                color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", marginTop: "3px", fontFamily: "Inter400", maxWidth: "100%",         // Ensures text wraps within the container
                whiteSpace: "normal",     // Allows normal wrapping (default but safe)
                textAlign: "justify",     // Aligns both sides (left + right)
                lineHeight: "1.5"
}}>
            {/* Triveni Management Consultancy Services Limited makes no liabilities or representations, express or implied, on products
            offered through the platform. It accepts no liability for any damages or losses, however caused, in connection with the
            use of, or on the reliance of its product or related services. Unless otherwise specified, all returns, expense ratation,
            NAV, etc are historical and for illustrative purposes only. Future will vary greatly and depends on personal and market
            circumstances. The information provided by our website is educational only and is not investment or tax advice. */}

                {t.text11}
        </Typography>
              <Typography style={{
                color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", marginTop: "3px", fontFamily: "Inter400", maxWidth: "100%",         // Ensures text wraps within the container
                whiteSpace: "normal",     // Allows normal wrapping (default but safe)
                textAlign: "justify",     // Aligns both sides (left + right)
                lineHeight: "1.5"
}}>
          {/* Investing in equities, derivatives, indices, futures and options are subject to market risks. Please read all scheme related documents carefully before investing. Past performance of the scheme is neither an indicator nor a guarantee of future performance */}
                {t.text12}
          </Typography>
              <Typography style={{ color: "#FFFFFF", fontSize: "calc(12px + var(--font-delta))", marginTop: "3px",fontFamily:"Inter400"  }}>
            {/* Terms and conditions of the website/app are applicable. Privacy policy of the website is applicable. */}

                {t.text13}
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 4, borderColor: "#2C2C2C" }} />

                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                          {/* <Stack direction="row" spacing={2}>
                              {[LinkedIn, Facebook, Instagram, YouTube].map((Icon, idx) => (
                                  <Box
                                      key={idx}
                                      sx={{
                                        backgroundColor: "#F0F0F0",
                                          borderRadius: "50%",
                                          width: 36,
                                          height: 36,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                      }}
                                  >
                                  <Icon sx={{ fontSize: 24, color: "#E93333" }} />
                                  </Box>
                              ))}
                          </Stack> */}

              <Stack direction="row" spacing={2}>
                {socialLinks.map((item, idx) => (
                  <Box
                    key={idx}
                    component="a"
                    href={item.link}
                    target="_blank"
                    aria-label={`Visit our ${item.name} page`}
                    title={item.name}
                    rel="noopener noreferrer"
                    sx={{
                      backgroundColor: "#F0F0F0",
                      borderRadius: "50%",
                      width: 36,
                      height: 36,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "#E93333",
                      },
                    }}
                  >
                    <item.icon aria-hidden="true" sx={{ fontSize: "calc(24px + var(--font-delta))", color: "#E93333", "&:hover": { color: "#fff" } }} />
                  </Box>
                ))}
              </Stack>

                    </Grid>

                    <Grid item>
              <Typography color="#FFFFFF" sx={{
                fontSize: "calc(16px + var(--font-delta))" ,fontFamily:"Inter400","@media (max-width:580px)": {
                                    mt:4,
                                }}}>
                      {/* Copyright © 2025 tradeboss.co All rights reserved. */}
                {t.copyrights}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
